import { endpoints } from 'constants/endpoints';

import { sendRequest } from './sendRequest';

/*
  Organization
 */
export const getOrganizationApi = (orgId) => {
  const url = endpoints.admin.organization(orgId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const updateOrganizationApi = (org) => {
  const url = endpoints.admin.organization(org.uuid);
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: org,
  });
};

export const mediaUploadApi = (file) => {
  const url = endpoints.admin.mediaUpload;
  const data = new FormData();
  data.append('attachment', file);
  data.append('mediaType', 'IMAGE');
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: data,
    isMultiPart: true,
  });
};

/*
  Organization Tag
 */
export const getOrganizationTagsApi = ({ teamId, tagType, orgTagId }) => {
  const url = endpoints.admin.organizationTag;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      tagType,
      teamId,
      parentId: orgTagId,
    },
  });
};

/*
  Organization Tag
 */
export const getCompetenciesApi = () => {
  const url = endpoints.admin.competencies;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getRoleBasedCompetenciesEnabledApi = () => {
  const url = endpoints.admin.roleBasedCompetency;
  return sendRequest({
    url,
    credentials: 'include',
  });
};

export const getOrganizationGradesApi = () => {
  const url = endpoints.admin.grades;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};
export const reorderOrganizationGradesApi = ({ jobGrades }) => {
  const url = endpoints.admin.reorderGrades;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: {
      jobGrades,
    },
  });
};
export const getOrganizationFunctionsApi = () => {
  const url = endpoints.admin.functions;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getCohortManagersListApi = () => {
  const url = endpoints.admin.managersList;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const saveOrganizationTagApi = ({ orgTag, teamId, tagType, parentTagId }) => {
  const url = endpoints.admin.organizationTag;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      team: teamId
        ? {
            uuid: teamId,
          }
        : null,
      parentTag: parentTagId ? { uuid: parentTagId } : null,
      tagType,
      ...orgTag,
    },
  });
};

export const saveCompetencyApi = ({ orgTag, jobFunctionRole = null }) => {
  const url = endpoints.admin.saveCompetency;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      organizationTag: orgTag,
      jobFunctionRole,
    },
  });
};

export const updateCompetencyApi = ({ orgTag, jobFunctionRole = null }) => {
  const url = endpoints.admin.competencyId(orgTag.id);
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: {
      organizationTag: orgTag,
      jobFunctionRole,
    },
  });
};

export const getCompetenciesForEmployeeApi = ({ body }) => {
  const url = endpoints.admin.employeeCompetencies;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body,
  });
};

export const getApplicableCompetenciesForEmployeesApi = ({ body }) => {
  const url = endpoints.admin.applicableEmployeeCompetencies;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body,
  });
};

export const updateOrganizationTagApi = ({ tagId, orgTag, teamId, tagType, parentTagId }) => {
  const url = `${endpoints.admin.organizationTag}/${tagId}`;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: {
      team: teamId
        ? {
            uuid: teamId,
          }
        : null,
      parentTag: parentTagId ? { uuid: parentTagId } : null,
      tagType,
      ...orgTag,
    },
  });
};

/*
  Referral Code
 */
export const getReferralCodeApi = () => {
  const url = endpoints.admin.referralCode;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const shareReferralCodeApi = ({ referralCode, identifierId, identifierType }) => {
  const url = endpoints.admin.shareReferralCode;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      referralCode,
      identifierId,
      identifierType,
    },
  });
};

/* Bulk upload Employees */
export const uploadEmployeesCSVApi = (fileObject, sendInviteEmail) => {
  const url = endpoints.admin.bulkUploadConfig;
  const data = new FormData();
  data.append('file', fileObject);
  data.append('type', 'EMP_BULK_UPLOAD');
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: data,
    isMultiPart: true,
    queryParams: {
      sendEmail: sendInviteEmail,
    },
  });
};

/* Bulk upload Employees Status */
export const uploadEmployeeCSVStatusApi = ({ uploadType }) => {
  const url = endpoints.admin.bulkUploadEmployeesStatus;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: { uploadType },
  });
};

/* Bulk upload Employees Download failure file */
export const downloadEmployeeCSVStatusApi = (id) => {
  const url = endpoints.admin.downloadBulkUploadEmployees(id);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const uploadObjectivesCSVApi = (data) => {
  const url = endpoints.admin.bulkUploadWrapper;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: data,
    isMultiPart: true,
  });
};

export const uploadGoalsCSVApi = (data) => {
  const url = endpoints.admin.bulkUploadWrapper;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: data,
    isMultiPart: true,
  });
};

export const uploadCompetenciesCSVApi = (data) => {
  const url = endpoints.admin.bulkUploadWrapper;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: data,
    isMultiPart: true,
  });
};

export const getOrgModulesSettingsApi = () => {
  const url = endpoints.admin.orgModulesSettings;
  return sendRequest({
    url,
    credentials: 'include',
  });
};

export const setOrgModulesSettingsApi = ({ moduleType, moduleStatus }) => {
  const url = endpoints.admin.orgModulesSettings;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      module_type: moduleType,
      module_status: moduleStatus,
    },
  });
};

export const getObjectiveSettingsApi = () => {
  const url = endpoints.admin.timeBoundObjective.objectiveSettings;
  return sendRequest({
    url,
    credentials: 'include',
  });
};

export const setObjectiveSettingsApi = ({
  frequencyType,
  startMonth,
  defaultGoalVisibility,
  objectiveCreationAccess,
}) => {
  const url = endpoints.admin.timeBoundObjective.objectiveSettings;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: {
      frequencyType,
      startMonth,
      defaultGoalVisibility,
      objectiveCreationAccess,
    },
    queryParams: {
      version: 'v1',
    },
  });
};

export const setObjectiveBehaviourApi = ({
  frequencyType,
  startMonth,
  defaultGoalVisibility,
  objectiveCreationAccess,
}) => {
  const url = endpoints.admin.timeBoundObjective.objectiveBehaviourSettings;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: {
      frequencyType,
      startMonth,
      defaultGoalVisibility,
      objectiveCreationAccess,
    },
  });
};

export const setObjectiveDisplaySettingsApi = ({ moduleName, objectivesName, keyResultsName }) => {
  const url = endpoints.admin.timeBoundObjective.objectiveDisplaySettings;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: {
      moduleName,
      objectivesName,
      keyResultsName,
    },
    queryParams: {
      version: 'v1',
    },
  });
};

export const getTimeBoundTimePeriodsApi = () => {
  const url = endpoints.admin.timeBoundObjective.timeBoundList;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      version: 'v1',
    },
  });
};

export const getTimeBoundObjectivesApi = (queryParamsObj) => {
  const url = endpoints.admin.timeBoundObjective.timePeriodObjectives;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: queryParamsObj,
  });
};

export const getObjectiveTimelineListApi = () => {
  const url = endpoints.admin.timeBoundObjective.objectiveTimeline;
  return sendRequest({
    url,
    credentials: 'include',
  });
};

export const importTimePeriodObjectivesApi = ({ sourceTimePeriod, targetTimePeriod }) => {
  const url = endpoints.admin.timeBoundObjective.importTimePeriodObjectives;
  return sendRequest({
    url,
    credentials: 'include',
    method: 'POST',
    body: {
      source: sourceTimePeriod,
      target: targetTimePeriod,
    },
  });
};

export const getObjectiveTimeboundFromIdApi = ({ objectiveTimeBoundId, objectiveId, timeBoundId }) => {
  const url = endpoints.admin.timeBoundObjective.getTimeBoundObjective;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      objectiveTimeBoundId,
      objectiveId,
      timeBoundId,
    },
  });
};

export const saveObjectiveApi = ({ tag }) => {
  const url = endpoints.admin.timeBoundObjective.timePeriodObjectives;
  return sendRequest({
    url,
    credentials: 'include',
    method: 'POST',
    body: { ...tag },
  });
};

export const updateObjectiveApi = ({ tag, updateAllInstances = false, renameObjective = false }) => {
  const url = endpoints.admin.timeBoundObjective.updateObjective(tag.uuid);

  return sendRequest({
    url,
    credentials: 'include',
    method: 'PUT',
    body: { ...tag },
    queryParams: {
      updateAllInstances,
      renameObjective,
    },
  });
};

export const cloneObjectiveApi = ({ tag, objectiveTimeBoundId, includeObjectiveTree = false }) => {
  const url = endpoints.admin.timeBoundObjective.cloneObjective;
  // exclude non required keys
  const { ...required } = tag;
  return sendRequest({
    url,
    credentials: 'include',
    method: 'POST',
    body: { ...required },
    queryParams: {
      includeObjectiveTree,
      objectiveTimeBoundId,
    },
  });
};

export const deleteObjectiveApi = ({ objectiveTimeBoundId, archiveObjectiveTree = false, isDeleteRevamp = false }) => {
  const url = endpoints.admin.timeBoundObjective.deleteObjective(objectiveTimeBoundId);

  return sendRequest({
    url,
    credentials: 'include',
    method: 'DELETE',
    queryParams: {
      archiveObjectiveTree,
      isDeleteRevamp,
    },
  });
};

export const getNotificationChannelDetailsApi = () => {
  const url = endpoints.admin.notificationSettings.channelDetailsList;
  return sendRequest({
    url,
    credentials: 'include',
  });
};

export const toggleNotificationChannelApi = ({ uuid, channelType, enabled }) => {
  const url = endpoints.admin.notificationSettings.channelDetailsForOrg;
  return sendRequest({
    url,
    credentials: 'include',
    method: 'PUT',
    body: {
      uuid,
      channelType,
      enabled,
    },
  });
};

export const toggleNotificationChannelForEmployeesApi = ({
  uuid,
  channelType,
  enabled,
  isEmployeeNotificationSettings = false,
}) => {
  const url = isEmployeeNotificationSettings
    ? endpoints.admin.notificationSettings.channelDetailsForEmp
    : endpoints.admin.notificationSettings.channelDetailsForOrg;

  return sendRequest({
    url,
    credentials: 'include',
    method: 'PUT',
    body: {
      uuid,
      channelType,
      enabled,
    },
  });
};
export const getTimeBoundObjectivesTreeApi = ({
  timeBound,
  filters,
  startTS,
  endTS,
  teamId,
  selectedCohort = null,
}) => {
  const url = endpoints.admin.timeBoundObjective.objectiveTree;
  const body = {
    orderBy: null,
    timeBounds: [timeBound],
    filter: filters,
  };
  if (selectedCohort) {
    body.cohort = selectedCohort;
  } else {
    body.pageType = {
      uuid: teamId,
      filterTagType: 'TEAM',
    };
  }
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      endTS,
      startTS,
    },
    method: 'POST',
    body,
  });
};

export const getNotificationEventChannelDetailsApi = ({ isEmployeeNotificationSettings = false }) => {
  const url = isEmployeeNotificationSettings
    ? endpoints.admin.notificationSettings.eventMappingListForEmp
    : endpoints.admin.notificationSettings.eventMappingListForOrg;

  return sendRequest({
    url,
    credentials: 'include',
  });
};

export const toggleNotificationEventChannelApi = ({
  moduleType,
  mainEventType,
  channelType,
  channelState,
  isEmployeeNotificationSettings = false,
}) => {
  const url = isEmployeeNotificationSettings
    ? endpoints.admin.notificationSettings.eventChannelMappingForEmp
    : endpoints.admin.notificationSettings.eventChannelMappingForOrg;
  return sendRequest({
    url,
    credentials: 'include',
    method: 'PUT',
    body: {
      moduleType,
      mainEventType,
      channelType,
      channelState,
    },
  });
};

export const setDefaultNotificationSettingsApi = () => {
  const url = endpoints.admin.notificationSettings.setToDefault;
  return sendRequest({
    url,
    credentials: 'include',
    method: 'POST',
  });
};

export const resetDefaultNotificationSettingsApi = ({ isMeshDefaultMapping }) => {
  const url = endpoints.admin.notificationSettings.resetToDefault(isMeshDefaultMapping);
  return sendRequest({
    url,
    credentials: 'include',
    method: 'POST',
  });
};
export const resetDefaultNotificationSettingForEmployeesApi = () => {
  const url = endpoints.admin.notificationSettings.setToOrgDefaultForEmp;
  return sendRequest({
    url,
    credentials: 'include',
    method: 'POST',
  });
};
export const getObjectiveHierarchyIdsApi = ({ objectiveTimeBoundId }) => {
  const url = endpoints.admin.timeBoundObjective.objectiveHierarchyIds;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      objectiveTimeBoundId,
    },
    // method: 'GET',
  });
};

export const generateCSVDataApi = () => {
  const url = endpoints.admin.generateEmployeeDataFile;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: { text: '', tagType: 'EMPLOYEE_NAME' },
  });
};

export const getEmployeeCountApi = ({ orgId, monthlyActive = true }) => {
  const url = endpoints.admin.employeeCount;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      orgId,
      monthlyActive,
    },
  });
};

// GOAL PREFERENCES

export const getAllTemplatesApi = () => {
  const url = endpoints.admin.goalPreferences.template;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};
export const getSpecificTemplateApi = (templateId) => {
  const url = endpoints.admin.goalPreferences.specificTemplate(templateId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};
export const getSelectedTemplateApi = () => {
  const url = endpoints.admin.goalPreferences.selectedTemplate;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};
export const setSelectedTemplateApi = (templateId) => {
  const url = endpoints.admin.goalPreferences.selectedTemplate;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      'template-id': templateId,
    },
  });
};

export const createTemplateApi = (body) => {
  const url = endpoints.admin.goalPreferences.template;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body,
  });
};
export const updateTemplateApi = (templateId, body) => {
  const url = endpoints.admin.goalPreferences.selectedTemplate;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      'template-id': templateId,
    },
    body,
  });
};
export const deleteTemplateApi = (templateId) => {
  const url = `${endpoints.admin.goalPreferences.template}/${templateId}`;
  return sendRequest({
    url,
    method: 'DELETE',
    credentials: 'include',
  });
};
